import { TreeNode } from '@Components/Tree/type';

import { createContext, useCallback, useContext, useState } from 'react';
export const useTargetList = () => {
  const [inputValue, setInputValue] = useState('');
  const handleSearchValueChange = useCallback((e: any) => {
    setInputValue(e.target.value.trim());
  }, []);
  const [readonlyList, setReadonlyList] = useState<any[]>([]);
  const handleReadonlyListChange = useCallback((value: any[]) => {
    setReadonlyList(value);
  }, []);
  const [displayList, setDisplayList] = useState<TreeNode[]>([]);
  const handleDisplayListChange = useCallback((value: any[]) => {
    setDisplayList(value);
  }, []);
  return {
    inputValue,
    handleSearchValueChange,
    readonlyList,
    handleReadonlyListChange,
    displayList,
    handleDisplayListChange,
  };
};
type TargetListContext = ReturnType<typeof useTargetList>;
const TargetListContext = createContext<TargetListContext | null>(null);
export const TargetListProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <TargetListContext.Provider value={useTargetList()}>
      {children}
    </TargetListContext.Provider>
  );
};
export const useTargetListContext = () => {
  const context = useContext(TargetListContext);
  if (!context) {
    throw new Error(
      'TargetListContext compound components cannot be rendered outside the TargetList component'
    );
  }
  return context;
};
